import { RootState } from "@/state/reducer";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Greeting from "./pages/greeting";
import TestStepOne from "./pages/testStepOne";
import TestStepTwo from "./pages/testStepTwo";
import TestStepThree from "./pages/testStepThree";
import Complete from "./pages/complete";
import { mtexts } from "./testmoderation";
import { getTextModerationResult } from "./utils";

const vesrion = "0.1.1";

const App = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();

  /* useEffect(() => {
    for (let t of mtexts) {
    const moderation = getTextModerationResult(t);
    console.log("Moderation:", moderation);
   }
  }, []) */

  const page = (() => {
    switch (State.selectedTab) {
      case "step1":
        return <TestStepOne />;
      case "step2":
        return <TestStepTwo />;
      case "step3":
        return <TestStepThree />;
      case "finish":
        return <Complete />;
      default:
        return <Greeting />;
    }
  })();

  return (
    <div className="app">
      {page}
      <div className="version">{vesrion}</div>
    </div>
  );
};

export default App;
